"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _airbnbPropTypes = require("airbnb-prop-types");

var _propTypes = require("prop-types");

var _selectionGroup = _interopRequireDefault(require("./selectionGroup"));

var _option = require("./option");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SingleSelectionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SingleSelectionGroup, _React$Component);

  function SingleSelectionGroup(_props) {
    var _this;

    _classCallCheck(this, SingleSelectionGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SingleSelectionGroup).call(this, _props));

    _defineProperty(_assertThisInitialized(_this), "getSelectedValue", function () {
      var selectedValues = _react.default.Children.map(_this.props.children, function (_ref) {
        var props = _ref.props;
        return props.selected ? props.value : undefined;
      });

      return selectedValues[0];
    });

    _defineProperty(_assertThisInitialized(_this), "onOptionChange", function (_ref2) {
      var target = _ref2.target;
      var selectedOption = target.value;

      _this.setState({
        selectedOption: selectedOption
      }, function () {
        _this.props.onChange({
          target: {
            value: selectedOption
          }
        });
      });
    });

    _this.state = {
      selectedOption: _this.getSelectedValue()
    };
    return _this;
  }

  _createClass(SingleSelectionGroup, [{
    key: "render",
    value: function render() {
      var selectedOption = this.state.selectedOption;

      var _this$props = this.props,
          ignored = _this$props.onChange,
          remainderProps = _objectWithoutProperties(_this$props, ["onChange"]);

      return _react.default.createElement(_selectionGroup.default, _extends({
        onChange: this.onOptionChange
      }, remainderProps), _react.default.Children.map(this.props.children, function (child) {
        return _react.default.cloneElement(child, {
          selected: selectedOption === child.props.value
        });
      }));
    }
  }]);

  return SingleSelectionGroup;
}(_react.default.Component);

var MultipleSelectionGroup =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(MultipleSelectionGroup, _React$Component2);

  function MultipleSelectionGroup(_props2) {
    var _this2;

    _classCallCheck(this, MultipleSelectionGroup);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(MultipleSelectionGroup).call(this, _props2));

    _defineProperty(_assertThisInitialized(_this2), "getSelectedValues", function () {
      return _react.default.Children.toArray(_this2.props.children).reduce(function (selectedItems, _ref3) {
        var props = _ref3.props;
        return _objectSpread({}, selectedItems, {}, _defineProperty({}, props.value, !!props.selected));
      }, {});
    });

    _defineProperty(_assertThisInitialized(_this2), "selectionToValue", function (selectedOptions) {
      var options = Object.keys(selectedOptions).reduce(function (values, currentValue) {
        return selectedOptions[currentValue] ? [].concat(_toConsumableArray(values), [currentValue]) : values;
      }, []).join();
      return {
        target: {
          value: options
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this2), "onOptionChange", function (_ref4) {
      var target = _ref4.target;
      var selectedOptions = _this2.state.selectedOptions;
      var newValue = !selectedOptions[target.value];

      _this2.setState({
        selectedOptions: _objectSpread({}, selectedOptions, _defineProperty({}, target.value, newValue))
      }, function () {
        var selectedOptions = _this2.state.selectedOptions;

        _this2.props.onChange(_this2.selectionToValue(selectedOptions));
      });
    });

    _this2.state = {
      selectedOptions: _this2.getSelectedValues()
    };
    return _this2;
  }

  _createClass(MultipleSelectionGroup, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var selectedOptions = this.state.selectedOptions;

      var _this$props2 = this.props,
          ignored = _this$props2.onChange,
          remainderProps = _objectWithoutProperties(_this$props2, ["onChange"]);

      return _react.default.createElement(_selectionGroup.default, _extends({
        onChange: this.onOptionChange
      }, remainderProps), _react.default.Children.map(this.props.children, function (child) {
        return _react.default.cloneElement(child, {
          onChange: _this3.onOptionChange,
          selected: selectedOptions[child.props.value]
        });
      }));
    }
  }]);

  return MultipleSelectionGroup;
}(_react.default.Component);

var SelectionGroupStateful = function SelectionGroupStateful(props) {
  return props.multiple ? _react.default.createElement(MultipleSelectionGroup, props) : _react.default.createElement(SingleSelectionGroup, props);
};

var sizeProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('small', 'large');
var stateProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('error', 'warning');
SelectionGroupStateful.propTypes = {
  /** {---} Sequence of: @@<SelectionGroupStateful.Option>@@ */
  children: _propTypes.any.isRequired,
  multiple: _propTypes.bool,
  fluid: _propTypes.bool,
  primary: _propTypes.bool,

  /** {bool} Mutually exclusive props: @@error@@ @@warning@@ */
  error: stateProps,

  /** {bool} Mutually exclusive props: @@error@@ @@warning@@ */
  warning: stateProps,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  small: sizeProps,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  large: sizeProps,
  onChange: _propTypes.func.isRequired
};
SelectionGroupStateful.Option = _option.Option;
var _default = SelectionGroupStateful;
exports.default = _default;
SelectionGroupStateful.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SelectionGroupStateful",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} Sequence of: @@<SelectionGroupStateful.Option>@@"
    },
    "multiple": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "fluid": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "primary": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "error": {
      "type": {
        "name": "custom",
        "raw": "stateProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@error@@ @@warning@@"
    },
    "warning": {
      "type": {
        "name": "custom",
        "raw": "stateProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@error@@ @@warning@@"
    },
    "small": {
      "type": {
        "name": "custom",
        "raw": "sizeProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    },
    "large": {
      "type": {
        "name": "custom",
        "raw": "sizeProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    }
  }
};